/**
 * **NOTE** The component in this file is a direct copy of the styles found at:
 * `src/modules/templateEditor/EditPush/`.
 *
 * Like everything else in this module, this work exists under the assumption that it is temporary.
 * We _should_ be using the templateEditor module's preview for this module, but the current template diff
 * module does not fetch its data from grapqhl, a necessity for the templateEdit preview.
 */

import { IosPlaceholder } from 'ui/icons/devices/IosPlaceholder';
import {
  ExpandedNotificationAttachmentIos,
  ExpandedNotificationBubbleIosContent,
  ExpandedNotificationBubbleIosContentHeaderSender,
  ExpandedNotificationBubbleIosContentHeader,
  ExpandedNotificationBubbleWrapper,
  ExpandedNotificationPlaceholder,
  NotificationBubbleIosContentBody,
  NotificationBubbleIosContentBodyMsg,
  NotificationContentWrapper,
  ExpandedNotificationAttachmentWrapperIos,
  ExpandedNotificationBubbleIos,
  ExpandedNotificationBubbleIosHeaderAndBodyWrapper,
} from './ContentPreviewPush.styled';
import type { TemplateDiffContentPush } from '../../../types';

type ExpandedNotificationIosProps = TemplateDiffContentPush;

export const ExpandedNotificationIos = ({
  title,
  message,
  attachmentUrlIos,
}: ExpandedNotificationIosProps) => {
  return (
    <ExpandedNotificationBubbleWrapper>
      <ExpandedNotificationBubbleIos>
        <ExpandedNotificationBubbleIosContent>
          <ExpandedNotificationBubbleIosContentHeader>
            <ExpandedNotificationPlaceholder>
              <IosPlaceholder height={24} width={24} />
            </ExpandedNotificationPlaceholder>
            <ExpandedNotificationBubbleIosHeaderAndBodyWrapper>
              <ExpandedNotificationBubbleIosContentHeaderSender>
                {title}
              </ExpandedNotificationBubbleIosContentHeaderSender>
              <NotificationContentWrapper>
                <NotificationBubbleIosContentBody>
                  <NotificationBubbleIosContentBodyMsg data-test={'push-preview-ios-message'}>
                    {message}
                  </NotificationBubbleIosContentBodyMsg>
                </NotificationBubbleIosContentBody>
              </NotificationContentWrapper>
            </ExpandedNotificationBubbleIosHeaderAndBodyWrapper>
          </ExpandedNotificationBubbleIosContentHeader>
        </ExpandedNotificationBubbleIosContent>
        {attachmentUrlIos && (
          <ExpandedNotificationAttachmentWrapperIos data-test="template-diff-push-preview-ios-image">
            <ExpandedNotificationAttachmentIos src={attachmentUrlIos} alt="IOS Push Image" />
          </ExpandedNotificationAttachmentWrapperIos>
        )}
      </ExpandedNotificationBubbleIos>
    </ExpandedNotificationBubbleWrapper>
  );
};
